import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "contracts-box_title" }
const _hoisted_2 = { class: "contracts-box_selections contracts-results_box-grid-lg2col" }
const _hoisted_3 = { class: "contracts-box_selection contracts-box_selection-checkmarks" }
const _hoisted_4 = { class: "form__label--rubik" }
const _hoisted_5 = { class: "cash-pricing__filter-item cash-pricing__filter-item--search" }
const _hoisted_6 = { class: "contract-dropdown-option" }
const _hoisted_7 = {
  key: 0,
  class: "contracts-field-required"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "contracts-box_selection contracts-box_selection-checkmarks" }
const _hoisted_10 = { class: "form__label--rubik" }
const _hoisted_11 = { class: "contract-dropdown-option" }
const _hoisted_12 = {
  key: 0,
  class: "contracts-field-required"
}
const _hoisted_13 = { class: "contracts-box_selection" }
const _hoisted_14 = { class: "form__label--rubik" }
const _hoisted_15 = { class: "contracts-box_selection-radio" }
const _hoisted_16 = ["onClick", "onUpdate:modelValue", "value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "form__indicator--grey" }, null, -1)
const _hoisted_18 = { class: "form__label--rubik form__label--thin" }
const _hoisted_19 = {
  key: 0,
  class: "contracts-field-required"
}
const _hoisted_20 = { class: "contracts-box_selection" }
const _hoisted_21 = { class: "form__label--rubik" }
const _hoisted_22 = { class: "contracts-box_selection contracts-box_selection-manage" }
const _hoisted_23 = { class: "form__label--rubik" }
const _hoisted_24 = ["onClick", "value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form__indicator--grey" }, null, -1)
const _hoisted_26 = { class: "form__label--rubik form__label--thin" }
const _hoisted_27 = {
  key: 0,
  class: "contracts-field-required"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_vit_dropdown = _resolveComponent("vit-dropdown")!
  const _component_vit_range_input = _resolveComponent("vit-range-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formTranslations.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formTranslations.location), 1),
        _createVNode(_component_vit_dropdown, {
          label: _ctx.formSelectionValue.location? _ctx.formSelectionValue.location : _ctx.formTranslations.select,
          light: "",
          rounded: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dropdown_item, { "prevent-close-dropdown": true }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_icon, {
                    class: "icon",
                    name: "icn-search"
                  }),
                  _createElementVNode("input", {
                    class: "cash-pricing__filter-search",
                    type: "text",
                    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSearchLocation && _ctx.onSearchLocation(...args)))
                  }, null, 32)
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocations, (location) => {
              return (_openBlock(), _createBlock(_component_dropdown_item, {
                key: location.id,
                onClick: ($event: any) => (_ctx.onLocationChange(location))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["contract-dropdown-checkmark", { 'checkmark-active': _ctx.formSelectionValue.location === location.description}])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(location.description), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.requiredTest && !_ctx.formSelectionValue.location)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.formTranslations.requiredfield), 1))
          : _createCommentVNode("", true),
        (_ctx.locationsLink && _ctx.formTranslations.allLocations)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "button button--borderless",
              href: _ctx.locationsLink,
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(_ctx.formTranslations.allLocations), 9, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formTranslations.commodity), 1),
        _createVNode(_component_vit_dropdown, {
          label: _ctx.formSelectionValue.commodity? _ctx.formSelectionValue.commodity : _ctx.formTranslations.select,
          light: "",
          rounded: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodities, (commodity) => {
              return (_openBlock(), _createBlock(_component_dropdown_item, {
                key: commodity.id,
                onClick: ($event: any) => (_ctx.formSelectionValue.commodity=commodity.label)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["contract-dropdown-checkmark", { 'checkmark-active': _ctx.formSelectionValue.commodity === commodity.label}])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(commodity.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.requiredTest && !_ctx.formSelectionValue.commodity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.formTranslations.requiredfield), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formTranslations.delivery), 1),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveriesDate, (delivery, index) => {
            return (_openBlock(), _createElementBlock("label", {
              class: _normalizeClass(["form__radio form__radio--nocenter", {'form__radio--nospace': index === 0}]),
              key: delivery.id
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                onClick: ($event: any) => (_ctx.onDeliveryChange(delivery)),
                "onUpdate:modelValue": ($event: any) => ((_ctx.formSelectionValue.delivery) = $event),
                value: delivery.id,
                class: "form__radio-input"
              }, null, 8, _hoisted_16), [
                [_vModelRadio, _ctx.formSelectionValue.delivery]
              ]),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(delivery.label), 1)
            ], 2))
          }), 128))
        ]),
        (_ctx.requiredTest && !_ctx.formSelectionValue.delivery)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.formTranslations.requiredfield), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formTranslations.direction), 1),
        _createVNode(_component_vit_range_input, {
          min: _ctx.directionMin,
          max: _ctx.directionMax,
          "init-value": _ctx.selectedRange,
          onValue: _ctx.onRangeChange,
          "right-desc": _ctx.priceHeadline.up,
          "left-desc": _ctx.priceHeadline.down
        }, null, 8, ["min", "max", "init-value", "onValue", "right-desc", "left-desc"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formTranslations.manage), 1),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.involvedClient, (manage) => {
            return (_openBlock(), _createElementBlock("label", {
              class: "form__radio form__radio--nospace form__radio--nocenter",
              key: manage.id
            }, [
              _createElementVNode("input", {
                type: "radio",
                onClick: ($event: any) => (_ctx.onTradingChange(manage)),
                value: manage.id,
                class: "form__radio-input"
              }, null, 8, _hoisted_24),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(manage.label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.requiredTest && !_ctx.selectedTrading.label)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.formTranslations.requiredfield), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}